export enum DestinationField {
    // default fields
    Name = 'name',
    Country = 'country',
    HousingsTotal = 'housings-total',
    HousingsDone = 'housings-done',
    HousingsImported = 'housings-imported',
    // additional fields
    LastImportDate = 'last-import-date',
}
